// Stav otevření průvodce okny — sdílený mezi spouštěčem (položka v menu „Nástroje") a kontejnerem,
// který průvodce vykresluje v desktop shellu. Drobný zustand store, žádná perzistence (ta je v
// windowOnboardingStorage „seen" flagu).

import { create } from 'zustand';

interface WindowOnboardingState {
  readonly open: boolean;
  /** Otevře průvodce (volá položka menu „Nástroje" i auto-open). */
  readonly openWizard: () => void;
  /** Zavře průvodce. */
  readonly closeWizard: () => void;
}

export const useWindowOnboardingStore = create<WindowOnboardingState>((set) => ({
  open: false,
  openWizard: () => set({ open: true }),
  closeWizard: () => set({ open: false }),
}));
